import { render, staticRenderFns } from "./passenger.vue?vue&type=template&id=da49fece&scoped=true&"
import script from "./passenger.vue?vue&type=script&lang=js&"
export * from "./passenger.vue?vue&type=script&lang=js&"
import style0 from "./passenger.vue?vue&type=style&index=0&id=da49fece&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da49fece",
  null
  
)

export default component.exports